import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import get from 'lodash/get';

import Form, { FormRow, FormControl } from 'rebook/apps/base/components/form/Form';
import FormTextInput from 'rebook/apps/base/components/form/FormTextInput';
import FormCheckbox from 'rebook/apps/base/components/form/FormCheckbox';
import validateForm from 'rebook/apps/base/components/form/validateForm';
import throttler from 'rebook/apps/utils/throttler';
import uaDetector from 'rebook/apps/utils/uaDetector';
import Button from 'rebook/apps/base/components/Button';
import FileInput from 'rebook/apps/base/components/FileInput';
import FilesInputArea from 'rebook/apps/base/components/FilesInputArea';
import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import * as NotificationActions from 'rebook/apps/users/actions/NotificationActions';
import * as UserBookshelfDetailActions from 'rebook/apps/users/actions/UserBookshelfDetailActions';
import { BOOK_SHELF_EDIT, MAX_BOOK_COVER_IMAGE_SIZE } from 'rebook/apps/users/constants';

import styles from './style.scss';


const MAXIMUM_NUMBER_CHARACHTERS = 50;

class BookshelfEditView extends React.Component {
  constructor(props) {
    super(props);
    const { bookshelfId } = props.match.params;
    this.state = {
      bookshelf: {},
      form: {},
      errorList: {},
      isInProgress: false,
      bookshelfId,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    const { bookshelfId: bookshelfIdParam } = this.props.match.params;
    if (bookshelfIdParam) {
      this.props.UserBookshelfDetailActions.fetchDetail(match)
        .then((data) => {
          const { name, is_public: isPublic, description, image } = data;
          this.setState({
            bookshelf: { name, is_public: isPublic, description, image },
            form: {
              name: {
                value: name,
              },
              is_public: isPublic,
              description: {
                value: description,
              },
            },
          });
        });
    }
  }

  componentDidUpdate() {
    const { match } = this.props;
    const { bookshelfId: bookshelfIdParam } = this.props.match.params;
    const { bookshelf } = this.props.userBookshelfDetail;
    if (bookshelfIdParam && !bookshelf || (bookshelf && bookshelf.id != bookshelfIdParam)) {
      this.props.UserBookshelfDetailActions.fetchDetail(match)
        .then((data) => {
          const { name, is_public: isPublic, description, image } = data;
          this.setState({
            bookshelf: { name, is_public: isPublic, description, image },
            form: {
              name: {
                value: name,
              },
              is_public: isPublic,
              description: {
                value: description,
              },
            },
          });
        });
    }
  }

  onBeforeSubmit() {
    if (!this.state.bookshelfId) {
      ga('send', 'event', {
        eventCategory: 'Shelves',
        eventAction: 'CreateShelf',
        eventLabel: 'MyShelves',
      });
      yaMetrikaReachGoal('CreateShelf');
    }
  }

  handleSubmit(submit) {
    const form = validateForm(this.state.form);
    this.setState({ isInProgress: true });
    submit(form);
  }

  cropString(name, maxLength) {
    if (!name) {
      return '';
    }
    return name.length > maxLength
      ? name.substring(0, MAXIMUM_NUMBER_CHARACHTERS) + '...'
      : name;
  }

  handleSuccess() {
    const { bookshelfId, form } = this.state;
    const { bookshelf } = this.props.userBookshelfDetail;
    this.setState({ isInProgress: false });
    if (bookshelfId) {
      let name = get(bookshelf, 'name', '');
      name = this.cropString(name, MAXIMUM_NUMBER_CHARACHTERS);
      this.props.NotificationActions.pop(BOOK_SHELF_EDIT.BOOK_SHELF_EDITED(name));
      throttler(this.props.history.goBack, 1000);
    }
    else {
      let name = get(form, 'name.value', '');
      name = this.cropString(name, MAXIMUM_NUMBER_CHARACHTERS);
      this.props.NotificationActions.pop(BOOK_SHELF_EDIT.BOOK_SHELVE_CREATED(name));
      throttler(this.props.history.goBack, 1000);
    }
  }

  handleError(errorList) {
    if (errorList.error) {
      return (
        this.setState({
          errorList: { name: [errorList.error.slice(6, -1)] },
          isInProgress: false,
        })
      );
    }
    this.setState({
      errorList,
      isInProgress: false,
    });

    if (errorList.non_field_errors) {
      this.props.NotificationActions.pop(errorList.non_field_errors, 'error');
    }
  }

  updateFormField(input) {
    this.setState(
      (prevState) => {
        return {
          errorList: {},
          form: {
            ...prevState.form,
            ...input,
          },
        };
      }
    );
  }

  handleInvalidImageFileSize() {
    this.props.NotificationActions.pop(BOOK_SHELF_EDIT.BOOK_SHELF_COVER_IMAGE_SIZE_ERROR);
  }

  handleInvalidImageFileType() {
    this.props.NotificationActions.pop(BOOK_SHELF_EDIT.BOOK_SHELF_COVER_IMAGE_TYPE_ERROR);
  }

  handleGetDroppedImage(imageData) {
    const { form } = this.state;
    this.setState({
      form: { ...form, ...{ image: { value: imageData } } },
    });
  }

  render() {
    const { isInProgress, errorList, bookshelf, bookshelfId, form } = this.state;
    const { name, description, is_public: isPublic, image } = bookshelf;
    const defaultName = name ? name : '';
    const defaultDescription = description ? description : '';
    const defaultChecked = !!bookshelf.hasOwnProperty('is_public') ? isPublic : true;
    const uploadedImage = get(form, 'image.value', '');
    let formUrl = '/api/v5/bookshelf/';
    let formMethod = 'post';

    if (bookshelfId) {
      formUrl = `/api/bookshelf/${bookshelfId}/`;
      formMethod = 'put';
    }

    const UA = get(navigator, 'userAgent', null);
    if (!UA) {
      return null;
    }

    const isMobile = uaDetector.isMobile(UA);

    return (
      <div className={styles.bookshelfCreate}>
        <div className={classNames(styles.bookshelfHeader, { isMobile })}>
          <FilesInputArea
            acceptTypes={['image/jpeg', 'image/png']}
            caption={'Перетащите или загрузите обложку'}
            extraClassName="jest-bookshelf-image-dropdown-area"
            isDisabled={isMobile}
            isInProgress={isInProgress}
            hiddenCaption={!!uploadedImage || !!image}
            maxFileSize={MAX_BOOK_COVER_IMAGE_SIZE}
            onSuccess={(data) => this.handleGetDroppedImage(data)}
            onInvalidFileSize={(data) => this.handleInvalidImageFileSize(data)}
            onInvalidFileType={(data) => this.handleInvalidImageFileType(data)}>
            {uploadedImage && (
              <img src={uploadedImage}
                className={classNames(styles.headerBackgroundContainerUploadedImage, 'jest-uploaded-image')} />
            )}
            {(image && !uploadedImage) && (
              <CroppedImage
                width={600}
                height={120}
                className={classNames(styles.headerBackgroundContainerImage, 'jest-bookshelf-image')}
                src={image}
                alt={defaultName} />
            )}
          </FilesInputArea>
        </div>
        <div className={classNames(styles.formContainer, 'section')}>
          <FileInput
            acceptTypes={['image/jpeg', 'image/png']}
            caption="Загрузить обложку"
            extraClassName={classNames(styles.uploadButton, 'jest-bookshelf-upload-cover-button')}
            isInProgress={isInProgress}
            maxFileSize={MAX_BOOK_COVER_IMAGE_SIZE}
            size="small"
            onAttach={(data) => this.handleGetDroppedImage(data)}
            onInvalidFileSize={(data) => this.handleInvalidImageFileSize(data)}
            onInvalidFileType={(data) => this.handleInvalidImageFileType(data)} />
          <Form
            action={formUrl}
            method={formMethod}
            extraClassName={classNames('jest-editbookshelf-form', styles.form)}
            onBeforeSubmit={() => this.onBeforeSubmit()}
            onSubmit={(callback) => this.handleSubmit(callback)}
            onSuccess={(data) => this.handleSuccess(data)}
            onError={(errorList) => this.handleError(errorList)}>
            <FormRow>
              <FormTextInput
                extraClassName={classNames('jest-editbookshelf-form-input-name', styles.input)}
                validationMessageExtraClassName="jest-editbookshelf-name-input-error"
                errorList={errorList.name}
                isDisabled={false}
                isRequired
                isRequiredError={BOOK_SHELF_EDIT.BOOKSHELF_NAME_IS_REQUIRED}
                value={defaultName}
                label="Название полки"
                onUpdate={(input) => this.updateFormField(input)}
                name="name" />
            </FormRow>
            <FormRow>
              <FormTextInput
                extraClassName={classNames(
                  'jest-editbookshelf-form-input-description',
                  styles.input,
                  styles.descriptionText,
                )}
                validationMessageExtraClassName="jest-editbookshelf-description-input-error"
                errorList={errorList.description}
                isDisabled={false}
                type="textarea"
                rows="10"
                value={defaultDescription}
                label="Опишите, о чем эта полка"
                onUpdate={(input) => this.updateFormField(input)}
                name="description" />
            </FormRow>
            <FormRow>
              <FormCheckbox
                className={classNames(styles.checkBox, 'jest-editbookshelf-is-public-checkbox')}
                id="id-is_public"
                name="is_public"
                type="checkbox"
                isChecked={defaultChecked}
                label={`Вашу подборку смогут видеть остальные читатели, 
                  а если вас случайно заметит наша редакция, 
                  она может попасть в список наших подборок.`}
                onUpdate={(input) => this.updateFormField(input)} />
            </FormRow>
            <FormControl>
              <Button
                type="submit"
                extraClassName="jest-save-editbookshelf-submit"
                size="small"
                isInProgress={isInProgress}>
                Сохранить
              </Button>
            </FormControl>
          </Form>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => ({
  userBookshelfDetail: state.userBookshelfDetail,
});

const mapDispatchToProps = (dispatch) => ({
  UserBookshelfDetailActions: bindActionCreators(UserBookshelfDetailActions, dispatch),
  NotificationActions: bindActionCreators(NotificationActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BookshelfEditView);
